import { render, staticRenderFns } from "./yqg-video.vue?vue&type=template&id=c4dbaa02&scoped=true&"
import script from "./yqg-video.vue?vue&type=script&lang=js&"
export * from "./yqg-video.vue?vue&type=script&lang=js&"
import style0 from "./yqg-video.vue?vue&type=style&index=0&id=c4dbaa02&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dbaa02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4dbaa02')) {
      api.createRecord('c4dbaa02', component.options)
    } else {
      api.reload('c4dbaa02', component.options)
    }
    module.hot.accept("./yqg-video.vue?vue&type=template&id=c4dbaa02&scoped=true&", function () {
      api.rerender('c4dbaa02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/snxguarantee/index/component/yqg-video/yqg-video.vue"
export default component.exports